export const TODOS = [
    {
        type: 'Bank change', when: '2 H AGO', urgent: true,
        title: 'Nordic Freight ApS changed its bank account',
        sub: 'New IBAN ending 4471. Call-back check completed by A. Sørensen, 11:40 today.',
        evidence: [
            { k: 'Previous', v: 'DK50 ···· ···· 9012' },
            { k: 'New', v: 'DK89 ···· ···· 4471' },
            { k: 'Source', v: 'Portal submission by supplier admin, verified by call-back to the number on file' },
        ],
        actions: [
            { label: 'Verify', kind: 'primary', verb: 'Verified' },
            { label: 'Reject', kind: 'reject', verb: 'Rejected', negative: true },
            { label: 'Open', kind: 'outline' },
        ],
    },
    {
        type: 'Savings gate · IL2', when: 'TODAY',
        title: 'Steel consolidation EU, IL2 Qualified',
        sub: '€620,000 annual value. Baseline locked 9 Jun. Awaiting your Finance validation.',
        evidence: [
            { k: 'Method', v: 'Unit price vs locked baseline (Savings Calculation Policy §3.1)' },
            { k: 'Baseline', v: '€2.84/kg avg, locked 9 Jun by M. Kessler' },
            { k: 'Quality gate', v: 'Passed, Procurement Excellence, 10 Jun' },
        ],
        actions: [
            { label: 'Approve', kind: 'primary', verb: 'Approved' },
            { label: 'Reject', kind: 'reject', verb: 'Rejected', negative: true },
            { label: 'Open', kind: 'outline' },
        ],
    },
    {
        type: 'Award sign-off · CoA', when: 'YESTERDAY',
        title: 'Logistics tender DK/SE, award to Scan Logistics',
        sub: '€410,000 over 2 years. Total contract value exceeds your €250,000 threshold.',
        evidence: [
            { k: 'Bid tab', v: '3 bidders, frozen 10 Jun. Scan Logistics ranked 1st on weighted score (74.2)' },
            { k: 'CoA rule', v: 'Contract commitment > €250,000 requires Org Admin sign-off (CoA v3)' },
        ],
        actions: [
            { label: 'Approve', kind: 'primary', verb: 'Approved' },
            { label: 'Reject', kind: 'reject', verb: 'Rejected', negative: true },
            { label: 'Open', kind: 'outline' },
        ],
    },
    {
        type: 'Portal review', when: 'YESTERDAY',
        title: 'Müller GmbH uploaded an ISO 9001 certificate',
        sub: 'Issued by TÜV Süd, valid to March 2028. Replaces the certificate expiring this month.',
        evidence: [
            { k: 'File', v: 'ISO9001_Mueller_2026.pdf, 1.2 MB' },
            { k: 'Check', v: 'Issuer, validity dates and company name read automatically and matched' },
        ],
        actions: [
            { label: 'Accept', kind: 'primary', verb: 'Accepted' },
            { label: 'Reject', kind: 'reject', verb: 'Rejected', negative: true },
            { label: 'Open', kind: 'outline' },
        ],
    },
    {
        type: 'Policy', when: '10 JUN',
        title: 'Procurement Policy v2.1 needs your acknowledgement',
        sub: 'Changes: gift limit lowered to €50, sourcing threshold raised to €25,000.',
        actions: [
            { label: 'Acknowledge', kind: 'primary', verb: 'Acknowledged' },
            { label: 'Read policy', kind: 'outline' },
        ],
    },
    {
        type: 'Certificate', when: '10 JUN',
        title: 'Vestas Components A/S insurance certificate expires in 14 days',
        sub: 'Renewal requested 28 May. No reply yet. Decide: chase again or flag the supplier.',
        actions: [
            { label: 'Chase again', kind: 'primary', verb: 'Reminder sent' },
            { label: 'Open supplier', kind: 'outline' },
        ],
    },
    {
        type: 'Business review', when: '9 JUN',
        title: 'Q2 review with Operations on Thursday',
        sub: 'The pack is ready: 2 open actions from last quarter need your status before the meeting.',
        actions: [{ label: 'Open pack', kind: 'primary' }],
    },
];
export const NOTIFS = [
    { title: 'Nordic Freight bank-detail change', sub: 'Awaiting your call-back verification · 1h ago', to: '/settings' },
    { title: '2 suppliers moved to financial grade D', sub: 'Risk update · today', to: '/suppliers' },
    { title: 'Steel index fell 4% since last review', sub: 'Category Intelligence · 2 days ago', to: '/category-intelligence' },
];
//# sourceMappingURL=data.js.map